import styled from '@emotion/styled';
import { weblog } from '@myrealtrip/logger';
import { useLogData } from '../LogDataContext';

const { LoggingImpression, LoggingClick } = weblog;

type BannerConfig = {
  startDate: string;
  endDate: string;
  image: string;
  landingUrl: string;
};

const BANNER_CONFIGS: BannerConfig[] = [
  {
    startDate: '2026-05-07T00:00:00+09:00',
    endDate: '2026-06-21T23:59:59+09:00',
    image: 'https://dry7pvlp22cox.cloudfront.net/mrt-images-prod/2026/05/07/HO1L/6Q3QWjQHlR.jpg',
    landingUrl: 'https://www.myrealtrip.com/promotions/mcbe2026',
  },
];

const DEFAULT_CONFIG = {
  image: 'https://dry7pvlp22cox.cloudfront.net/mrt-images-prod/2026/03/27/fgUp/sqpaCAD2dF.jpg',
  landingUrl: 'https://www.myrealtrip.com/pkc',
};

function getActiveBannerConfig() {
  const now = new Date();
  return (
    BANNER_CONFIGS.find(
      (config) => now >= new Date(config.startDate) && now <= new Date(config.endDate),
    ) ?? DEFAULT_CONFIG
  );
}

function PromotionBanner() {
  const contextLogData = useLogData();
  const config = getActiveBannerConfig();
  const imageUrl = config.image;
  const landingUrl = config.landingUrl;

  const bannerLogData = {
    screenName: 'search_home',
    eventName: 'ps_banner',
    pageCategory: contextLogData?.pageCategory ?? 'search_home',
    params: {
      itemKind: 'banner',
      image_url: imageUrl,
      target_url: landingUrl,
      ...contextLogData?.params,
    },
  };
  return (
    <LoggingImpression
      screenName={bannerLogData.screenName}
      eventName={bannerLogData.eventName}
      pageCategory={bannerLogData.pageCategory}
      params={bannerLogData.params}
      impressionOptions={{ key: 'ps_banner', threshold: 0.5 }}
    >
      <LoggingClick
        screenName={bannerLogData.screenName}
        eventName={bannerLogData.eventName}
        pageCategory={bannerLogData.pageCategory}
        params={bannerLogData.params}
      >
        <BannerLink href={landingUrl}>
          <BannerImage src={imageUrl} alt="프로모션 배너" />
        </BannerLink>
      </LoggingClick>
    </LoggingImpression>
  );
}

export default PromotionBanner;

const BannerLink = styled.a`
  display: block;
  padding: 8px 16px 0;
  cursor: pointer;
`;

const BannerImage = styled.img`
  width: 100%;
  border-radius: 8px;
  display: block;
`;
